import BaseModel from "./models/BaseModel";
import BaseObject from "./models/BaseObject";
import Logger from "./Logger";
const logger = new Logger();
export default class ContextMenuManager extends BaseObject {
  public get className(): string {
    return "ContextMenuManager"; // no itx
  }

  MENU_ID = "tree";

  contextMenuItems: any | undefined = undefined;
  disabledContextMenuItems = new Array<string>();
  clipboardData: any | undefined;
  private pendingShowTimers = new Set<ReturnType<typeof setTimeout>>();

  private scheduleShow(callback: () => void) {
    const timer = setTimeout(() => {
      this.pendingShowTimers.delete(timer);
      callback();
    }, 50);
    this.pendingShowTimers.add(timer);
  }

  async getDisabledContextMenuItems(obj: BaseModel) {
    logger.log("call getDisabledContextMenuItems ");
    const items = await obj.treeViewModel.getDisabledContextMenuItems();
    if (items) {
      logger.log("setDisabledItems", items);
      if (items.length > 0) {
        this.disabledContextMenuItems = items;
        this.contextMenuItems = obj.treeViewModel.contextMenuItems;
      }
    }
  }

  /** Moves copy/cut/paste/delete items to the very end of the items list. */
  private moveClipboardItemsToBottom(items: any[]): any[] {
    const BOTTOM_IDS = new Set(["copy", "cut", "paste", "delete"]);
    const top = items.filter((i) => !BOTTOM_IDS.has(i.id));
    const bottom = items.filter((i) => BOTTOM_IDS.has(i.id));
    return [...top, ...bottom];
  }

  async show(event: any, obj: BaseModel) {
    this.disabledContextMenuItems = new Array<string>();
    await this.getDisabledContextMenuItems(obj);
    this.contextMenuItems = obj.treeViewModel.contextMenuItems;

    // Auto-merge: add buttons (not yet in the menu) and any extra items
    const buttonItems = obj.treeViewModel.getButtonsAsContextMenuItems();
    const extraItems = obj.treeViewModel.getExtraContextMenuItems();
    if (buttonItems.length > 0 || extraItems.length > 0) {
      if (this.contextMenuItems) {
        const existingIconNames = new Set<string>(
          (this.contextMenuItems.items as any[]).map((i: any) => i.iconName).filter(Boolean),
        );
        const newButtonItems = buttonItems.filter((i) => !existingIconNames.has(i.iconName));
        this.contextMenuItems = {
          ...this.contextMenuItems,
          items: [...(this.contextMenuItems.items || []), ...newButtonItems, ...extraItems],
        };
      } else {
        this.contextMenuItems = { items: [...buttonItems, ...extraItems] };
      }
    }

    if (this.contextMenuItems && this.contextMenuItems.items.length > 0) {
      // Always keep copy/cut/paste/delete at the very bottom
      this.contextMenuItems = {
        ...this.contextMenuItems,
        items: this.moveClipboardItemsToBottom(this.contextMenuItems.items),
      };

      if (this.contextMenuItems.title == undefined || this.contextMenuItems.title == "") {
        this.contextMenuItems.title = obj.fullTag + " " + obj.name;
      }
      // raiseOnChange ....
      this.currentObject = obj;

      const isScreen2 = event.view.isScreen2;
      let w: any = window;
      if (isScreen2 && state.documentScreen2) {
        w = state.window2;
      }

      // timer..... to allow react to rerender the ContextMenu Content first
      this.scheduleShow(() => {
        if (this.contextMenuItems) {
          w.contextMenu.show({
            id: this.MENU_ID,
            event: event,
          });
        }
      });
    }
  }

  async show1(event: any, contextMenuItems: any, disabledContextMenuItems: any) {
    this.disabledContextMenuItems = disabledContextMenuItems;
    this.contextMenuItems = contextMenuItems;

    this.raiseOnChange("show1");
    if (this.contextMenuItems) {
      // timer..... to allow react to rerender the ContextMenu Content first
      this.scheduleShow(() => {
        const isScreen2 = event?.view?.isScreen2; // need to do the question mark for robot swquence
        let w: any = window;
        if (isScreen2 && state.documentScreen2) {
          w = state.window2;
        }

        if (this.contextMenuItems) {
          w.contextMenu.show({
            id: this.MENU_ID,
            event: event,
          });
        }
      });
    }
  }

  private _currentObject: BaseModel | undefined = undefined;

  get currentObject(): BaseModel | undefined {
    return this._currentObject;
  }

  set currentObject(obj: BaseModel | undefined) {
    this._currentObject = obj;
    this.raiseOnChange();
  }

  clear() {
    for (const timer of this.pendingShowTimers) {
      clearTimeout(timer);
    }
    this.pendingShowTimers.clear();
    this.contextMenuItems = undefined;
    this.disabledContextMenuItems = new Array<string>();
    this.clipboardData = undefined;
    this.currentObject = undefined;
  }
}
